import { FC } from 'react';
import { TransmissionActsList } from 'containers/transmission-acts';
import { TransmissionActsLayout } from 'pages/atoms';

const TransmissionActsPage: FC = () => {
  return (
    <TransmissionActsLayout>
      <TransmissionActsList />
    </TransmissionActsLayout>
  );
};

export default TransmissionActsPage;
